// extracted by mini-css-extract-plugin
export default {"root":"BankAccountForm_root__yTODr"};